export default __webpack_public_path__ + "static/media/mode-550.e432cef7.svg";